import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Toast } from 'antd-mobile';
import { getYcode } from '../../../service/chat-service';

import styles from './styles.module.less';

const propTypes = {
  phoneNumber: PropTypes.string,
  countdownTime: PropTypes.number, // 倒计时时间 秒为单位
  countdownUnit: PropTypes.number, // 倒计时步长值 单位为毫秒
  className: PropTypes.string,
  onClick: PropTypes.func,
  // type: PropTypes.number,
};

const defaultProps = {
  countdownTime: 60,
  countdownUnit: 1000,
  // type: 1,
  phoneNumber: '',
  className: '',
  onClick: () => {},
};

/**
 * 获取验证码
 */
class SendVRCode extends Component {
  timer = null;

  constructor(props) {
    super(props);
    const { countdownTime } = this.props;
    this.state = {
      countdown: countdownTime,
    };
  }

  handleCountDown = async () => {
    const { onClick } = this.props;

    const { countdownTime, countdownUnit, phoneNumber } = this.props;
    const { countdown } = this.state;

    if (!phoneNumber || (phoneNumber && phoneNumber.length < 11)) { return Toast.show('请检查手机号输入'); }
    if (countdown !== countdownTime) return false;

    this.setState({ countdown: countdown - countdownUnit / 1000 });

    try {
      const opt = {
        phone: phoneNumber,
      };
      const { code, message, data } = await getYcode(opt);
      if (code !== 10000) {
        if (onClick) onClick(code, message);
      } else if (onClick) onClick(code, message, data);

      this.timer = setInterval(() => {
        const { countdown: cd } = this.state;
        const newCountdown = cd - countdownUnit / 1000;

        if (newCountdown <= 0) {
          this.setState({ countdown: countdownTime });
          clearInterval(this.timer);
        } else {
          this.setState({ countdown: newCountdown });
        }
      }, countdownUnit);
    } catch (e) {
      clearInterval(this.timer);
      this.setState({ countdown: countdownTime });
      Toast.show(e.message || e || '获取验证码失败');
    }
    return false;
  };

  render() {
    const { className } = this.props;
    const { countdown } = this.state;
    const style = className || styles.PINCode;
    return (
      <>
        {countdown === 60 ? (
          <span onClick={this.handleCountDown} className={style} role="button" tabIndex={0}>
            获取验证码
          </span>
        ) : (
          <span className={style}>{`${countdown}秒`}</span>
        )}
      </>
    );
  }
}

SendVRCode.propTypes = propTypes;
SendVRCode.defaultProps = defaultProps;

export default SendVRCode;
